import React from "react";
import "./Benefits.css";
import arrow from "../../../assets/Line 7.png";
import { benefitsCardData } from "../../../data";

const Benefits = () => {
  return (
    <div className="benefits__section">
      <div className="benefits__section__heading">
        <h3>BENEFITS</h3>
        <h1>MULA TOKEN</h1>
        <div className="benefits__section__heading__image">
          <img src={arrow} alt="" />
        </div>
      </div>

      <div className="benefits__card__section">
        {benefitsCardData &&
          benefitsCardData.map((data, index) => {
            // eslint-disable-next-line no-unused-vars
            const { image, text } = data;

            return (
              <div className="benefits__card__container" key={index}>
                <div className="card benefits__card">
                  <div className="benefits__card__image">
                    <img src={image} alt="benefits card" />
                  </div>
                  <div className="card-body benefits__card__cardbody">
                    <p className="card-text">{text}</p>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default Benefits;
